import { matchPath, useLocation } from 'react-router-dom'

import {
  useCopyGanttMutation,
  useDeleteGanttByIdMutation,
  useDeleteViewMutation,
  useFetchAllObjectQuery,
} from '@redux/api'

import { useHandlers } from './useHandlers'

export const useConfigGantt = () => {
  const { pathname } = useLocation()
  const isAllGantt = matchPath('/gantt', pathname)
  const { data: objects } = useFetchAllObjectQuery()
  const [deleteGantt] = useDeleteViewMutation()
  const [deleteGanttById] = useDeleteGanttByIdMutation()
  const [copyGantt, { isLoading: isLoadingCopyGantt }] = useCopyGanttMutation()
  const { handlers, state } = useHandlers({
    deleteGantt,
    deleteGanttById,
    copyGantt,
  })

  return {
    data: {
      isAllGantt,
      objects,
      isLoadingCopyGantt,
    },
    state: {
      ...state,
    },
    handlers,
  }
}
